import { find } from 'lodash-es';
import Tippy from '@tippyjs/react';
import bem from '../../../utils/bem';
import damImageSwatchFormatter from '../../../utils/damImageSwatchFormatter';
import getBreakpoints from '../../../utils/breakpoints';

const Tile = (props) => {
  const {
    item,
    activeAttributes,
    filteredList,
    typeUsed,
    disabledMessage = Drupal.t('Disabled by your selection'),
    baseClass,
    triggerVariant,
    extraClasses = [],
  } = props;

  const active =
    activeAttributes &&
    activeAttributes?.[item.groupedBy] === item.attributeValue;
  const { isDesktop } = getBreakpoints();
  const modClasses = [];
  modClasses.push(active ? 'active' : '');
  modClasses.push(typeUsed);

  const isEnabledPDPHeroCarousel = !!item?.heroCarousel?.length;
  const disabledByFilter = () => {
    if (
      (activeAttributes &&
        Object.keys(activeAttributes).length === 1 &&
        activeAttributes[item.groupedBy]) ||
      !filteredList
    ) {
      return false;
    }
    return !find(filteredList, [item.groupedBy, item.attributeName]);
  };

  const disabled = disabledByFilter() || item.disabled;
  modClasses.push(item.disabled || disabled ? 'disabled' : '');

  const itemValue = (options = {}) => {
    if (typeUsed === 'image') {
      const swatchPDPImage = damImageSwatchFormatter(item.img, options);
      return (
        <img
          src={swatchPDPImage}
          alt={item.label}
          aria-hidden="true"
          loading="lazy"
        />
      );
    }
    if (item.label) return item.label;
    return item.value;
  };

  const message = () => {
    if (disabled) return disabledMessage;
    if (typeUsed === 'image') {
      const options = {
        damImageStyle: isDesktop ? '334x334' : '184x184',
      };
      let outputHtml;
      if (isEnabledPDPHeroCarousel) {
        outputHtml = (
          <>
            <div className="swatch-label">{item.label}</div>
          </>
        );
      } else {
        outputHtml = (
          <>
            {itemValue(options)}
            <div className="swatch-label">{item.label}</div>
          </>
        );
      }
      return outputHtml;
    }
    return false;
  };
  // Initial Set

  const handleClick = () => {
    if (disabled) return;
    if (typeof triggerVariant === 'function') {
      triggerVariant(item.groupedBy, item.attributeValue);
    }
  };

  const button = (
    <button
      className={bem('item', modClasses, baseClass, extraClasses)}
      onClick={handleClick}
      aria-label={item.label}
    >
      {itemValue()}
    </button>
  );

  return message() ? (
    <Tippy
      placement={'bottom'}
      content={message()}
      trigger={isDesktop ? `focus mouseenter` : `click focus`}
      className={'tippy-box--swatch'}
      onMount={(instance) => {
        instance.reference.removeAttribute('aria-describedby');
      }}
    >
      {button}
    </Tippy>
  ) : (
    button
  );
};

export default Tile;
